import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-circle",
  "use": "check-circle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"check-circle\"><g clip-path=\"url(#check-circle_a)\"><path opacity=\".8\" d=\"M7 .875a6.125 6.125 0 1 0 0 12.25A6.125 6.125 0 0 0 7 .876ZM9.646 5l-2.88 3.992a.435.435 0 0 1-.707 0L4.354 6.629a.11.11 0 0 1 .09-.173h.64c.14 0 .273.067.355.182l.973 1.35 2.15-2.98a.437.437 0 0 1 .353-.182h.642A.11.11 0 0 1 9.646 5Z\" /></g><defs><clipPath id=\"check-circle_a\"><path d=\"M0 0h14v14H0z\" /></clipPath></defs></symbol>"
});
var result = sprite.add(symbol);
export default symbol